import OrderItemFooter from './OrderItemFooter';

export default OrderItemFooter;
